
import React, { createContext, useState, useContext, useEffect } from "react";
import PropTypes from 'prop-types';
import { useParams } from "react-router-dom";

export const CurrentUserContext = createContext(null);

export const CurrentUserProvider = ({ children, userData }) => {
  const { orgId } = useParams();
  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserCanManage, setCurrentUserCanManage] = useState(false);

  useEffect(() => {
    // check if the url path ends with /org/:id, and if so, then get the id:
    // const path = window.location.pathname;
    // const orgId = path.split("/").pop();

    console.log(`inside of useEffect of current user context orgid: ${orgId} and currentUser: ${currentUser?.organization?.slug}`)
    if(orgId && currentUser?.organization?.slug) {
      currentUser.organization.slug === orgId ? setCurrentUserCanManage(true) : setCurrentUserCanManage(false)
    }
  }, [currentUser, orgId]);

  const fetchCurrentUser = async () => {
    if(userData && userData.email) {
      setCurrentUser(userData)
      return
    }

    let response = await fetch("/api/v1/users/current")
    const data = await response.json()

    if(data.email) {
      setCurrentUser(data)
    }
  }

  return (
    <CurrentUserContext.Provider value={{ currentUser, fetchCurrentUser, currentUserCanManage }}>
      {children}
    </CurrentUserContext.Provider>
  );
};

export const useCurrentUser = () => useContext(CurrentUserContext);
